export default __webpack_public_path__ + "static/media/gowling-wlg.74e2ebdd.svg";